import React from 'react';
import { CloudOff } from 'lucide-react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { useTranslation } from '../i18n';

interface ConnectionBannerProps {
  /** Whether a generation is in flight; changes what the user is warned about. */
  isGenerating?: boolean;
}

/**
 * Offline notice.
 *
 * Stated plainly because the consequence differs: losing the network mid-run
 * means the turn will not finish, and the user should stop waiting for it.
 */
export const ConnectionBanner: React.FC<ConnectionBannerProps> = ({ isGenerating = false }) => {
  const { language } = useTranslation();
  const isChinese = language === 'Chinese';
  const online = useOnlineStatus();

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="assertive"
      className="flex items-center justify-center gap-2 border-b border-amber-500/30 bg-amber-50 px-4 py-1.5 text-xs text-amber-800 dark:bg-amber-950/30 dark:text-amber-200"
    >
      <CloudOff className="h-3.5 w-3.5 shrink-0" />
      <span>
        {isGenerating
          ? (isChinese
            ? '网络已断开，本轮生成无法完成。恢复后请重试。'
            : 'Network lost — this generation cannot finish. Retry once you are back online.')
          : (isChinese ? '网络已断开' : 'You are offline')}
      </span>
    </div>
  );
};
